import React from 'react';

interface FormFieldProps {
  id: string;
  label: string;
  /** Affiche « (facultatif) » à côté du libellé. */
  optional?: boolean;
  error?: string;
  /** Fonction de rendu du contrôle : reçoit les attributs d'accessibilité à poser sur le champ. */
  children: (a11y: { id: string; 'aria-invalid': boolean; 'aria-describedby'?: string }) => React.ReactNode;
}

/** Libellé + champ + message d'erreur inline, avec aria-invalid et aria-describedby. */
export const FormField: React.FC<FormFieldProps> = ({ id, label, optional = false, error, children }) => {
  const errorId = `${id}-error`;
  return (
    <div>
      <label htmlFor={id} className="block text-xs font-medium text-fg-muted uppercase tracking-wider mb-1.5">
        {label}
        {optional && <span className="ml-1 normal-case tracking-normal text-fg-subtle">(facultatif)</span>}
      </label>
      {children({ id, 'aria-invalid': Boolean(error), 'aria-describedby': error ? errorId : undefined })}
      {error && (
        <p id={errorId} role="alert" className="mt-1.5 text-xs text-red-400">
          {error}
        </p>
      )}
    </div>
  );
};
